import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M100 60 86 50l2 26q-38-26-66 0 6 24-4 54 42-20 70-8l12 18 12-18q28-12 70 8-10-30-4-54-28-26-66 0l2-26Z" }, null, -1),
    _createElementVNode("circle", {
      cx: "92",
      cy: "90",
      r: "4",
      fill: "var(--mc-avatar)"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "108",
      cy: "90",
      r: "4",
      fill: "var(--mc-avatar)"
    }, null, -1)
  ]))]))
}
export default { render: render }